import { action, makeObservable, observable } from 'mobx';
import { iframeService, userInfoStore } from '@pascal/pascal-core';
// import { INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT } from '../enums/uiConfig';
import { gameLiveConnection } from '../services';
import { INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT } from '../enums/uiConfig';

class DoBetStore {
  disabledBetButton = { 0: false, 1: false };

  disabledCashOutButton = { 0: true, 1: true };

  userBets = { 0: null, 1: null };

  totalBetAmount = 0;

  win = null;

  maxPayoutData = {
    0: INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT,
    1: INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT,
  };

  constructor() {
    makeObservable(this, {
      win: observable,
      // maxPayoutData: observable.deep,
      totalBetAmount: observable,
      disabledBetButton: observable.deep,
      disabledCashOutButton: observable.deep,
      userBets: observable.deep,
      setWin: action.bound,
      cashOut: action.bound,
      resetDoBetStore: action.bound,
      // checkWin: action.bound,
      setUserBets: action.bound,
      setTotalBetAmount: action.bound,
      // resetMaxPayoutData: action.bound,
      updateMaxPayoutBetData: action.bound,
      setDisabledBetButton: action.bound,
      setDisabledCashOutButton: action.bound,
    });
  }

  setWin(winData) {
    this.win = winData;
  }

  setTotalBetAmount(totalBetAmount) {
    this.totalBetAmount = totalBetAmount;
  }

  setDisabledBetButton(disabledBetButton) {
    this.disabledBetButton = disabledBetButton;
  }

  setUserBets(userBets) {
    const totalStack = Object.keys(userBets)
      ?.map((item) => {
        return userBets?.[item]?.amount || 0;
      })
      ?.reduce((acc, curr) => acc + +curr, 0);
    iframeService.sendStakeUpdate(totalStack);
    this.userBets = userBets;
  }

  setDisabledCashOutButton(disabledCashOutButton) {
    this.disabledCashOutButton = disabledCashOutButton;
  }

  resetMaxPayoutData() {
    this.maxPayoutData = {
      0: INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT,
      1: INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT,
    };
  }

  updateMaxPayoutBetData(dataParam) {
    const {
      sectionId,
      updatedDataByKeys = null,
      updatedDataKey = null,
      newData = null,
    } = dataParam;

    if (sectionId || sectionId === 0) {
      this.maxPayoutData = {
        ...this.maxPayoutData,
        [sectionId]: {
          ...this.maxPayoutData[sectionId],
          ...(updatedDataKey && newData ? { [updatedDataKey]: newData } : updatedDataByKeys),
        },
      };
    }
  }

  incrementDemoBalance(amount, odd) {
    const balance = userInfoStore.balance + amount * odd;
    userInfoStore.setDemoBalance(balance);
  }

  // decrementBalance(amount) {
  //   userInfoStore.setDemoBalance(userInfoStore.balance - amount);
  // }

  cashOut({ sectionId, ...rest }) {
    gameLiveConnection.cashOut(rest);
    this.disabledCashOutButton = {
      ...this.disabledCashOutButton,
      [sectionId]: true,
    };
  }

  resetDoBetStore() {
    this.disabledBetButton = { 0: false, 1: false };
    this.disabledCashOutButton = { 0: true, 1: true };
    this.userBets = { 0: null, 1: null };
    this.totalBetAmount = 0;
    this.win = null;
  }
}

export const doBetStore = new DoBetStore();
